"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LoadingAnimation", {
  enumerable: true,
  get: function get() {
    return _LoadingAnimation["default"];
  }
});
var _LoadingAnimation = _interopRequireDefault(require("./LoadingAnimation"));